import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import PageOpener from "@/components/PageOpener";
import ChatWidget from "@/components/ChatWidget";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import HowItWorksPage from "@/pages/HowItWorksPage";
import StoryPage from "@/pages/StoryPage";
import ProductPage from "@/pages/ProductPage";
import ContactPage from "@/pages/ContactPage";
import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminSubscribers from "@/pages/admin/AdminSubscribers";
import AdminCoupons from "@/pages/admin/AdminCoupons";
import AdminNewsletter from "@/pages/admin/AdminNewsletter";
import AdminQrCards from "@/pages/admin/AdminQrCards";
import AdminChatHistory from "@/pages/admin/AdminChatHistory";
import AdminAiSettings from "@/pages/admin/AdminAiSettings";
import AdminPickups from "@/pages/admin/AdminPickups";
import AdminAccount from "@/pages/admin/AdminAccount";
import "@/App.css";

function App() {
  return (
    <div className="App">
      <PageOpener />
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/hogyan-mukodik" element={<HowItWorksPage />} />
            <Route path="/tortenetunk" element={<StoryPage />} />
            <Route path="/termek" element={<ProductPage />} />
            <Route path="/kapcsolat" element={<ContactPage />} />
          </Route>
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route element={<AdminLayout />}>
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/subscribers" element={<AdminSubscribers />} />
            <Route path="/admin/coupons" element={<AdminCoupons />} />
            <Route path="/admin/qr-cards" element={<AdminQrCards />} />
            <Route path="/admin/newsletter" element={<AdminNewsletter />} />
            <Route path="/admin/chat-history" element={<AdminChatHistory />} />
            <Route path="/admin/ai" element={<AdminAiSettings />} />
            <Route path="/admin/pickups" element={<AdminPickups />} />
            <Route path="/admin/account" element={<AdminAccount />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <ChatWidget />
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
